import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { Poll } from "../types/polls.types";

export function usePolls(broadcastId: string | null): Poll[] {
	const [polls, setPolls] = useState<Poll[]>([]);

	useEffect(() => {
		if (!broadcastId) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "polls"),
			orderBy("date", "desc"),
		);

		return onSnapshot(q, (snapshot) => {
			setPolls(snapshot.docs.map((doc) => ({ id: doc.id, ...(doc.data() as Omit<Poll, "id">) })));
		});
	}, [broadcastId]);

	return polls;
}
